import React, {Component} from "react";
import Success from "./success_notify";
import Error from "./error_notify";
import Info from "./info_notify";
import ProfessionalTrialNotify from "./professional_trial_notify";

import "components/Notifications/styles/index.scss";

class Notify extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.notify.isNotify !== nextProps.notify.isNotify && nextProps.notify.isNotify) {
            this.setState({open: true});

        }
    }

    handleClose = (e) => {
        e.preventDefault();
        this.setState({open: false});
    };

    render() {
        const {message, severity, from, type} = this.props.notify;
        return (
            <React.Fragment>
                {severity === "success" && (
                    this.state.open &&
                    <Success onClose={this.handleClose} type={type} from={from}/>
                )
                }
                {severity === "professional_trial" && (
                    this.state.open &&
                    <ProfessionalTrialNotify onClose={this.handleClose}/>
                )
                }
                {severity === "info" && (
                    this.state.open &&
                    <Info onClose={this.handleClose} type={type} from={from}/>
                )
                }
                {severity === "error" && (
                    this.state.open &&
                    <Error onClose={this.handleClose} message={message} from={from}/>
                )
                }
            </React.Fragment>
        );
    }
}

export default Notify;